import "core-js/modules/es.array.for-each";
import "regenerator-runtime/runtime";
import _asyncToGenerator from "/data/landun/workspace/codebase/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { delQueStr } from '@tencent/vft-common/util';
import IconCancel from '@vip-activity/ui/components/icon/IconCancel.vue';
import Avatar from '@vip-activity/ui/components/Avatar/Avatar.vue';
import TicketService from '@/service/ticket';
import config from '@/config';
import Bus from '@/util/eventBus';
import { cutStrWithEmoji } from '@/util/helper';
import { VIPICON } from '@/util/constant';
import HuoMask from '../HuoMask/HuoMask.vue';
var _window = window,
    VftShield = _window.VftShield;
export default {
  components: {
    IconCancel: IconCancel,
    Avatar: Avatar,
    HuoMask: HuoMask
  },
  data: function data() {
    return {
      visible: true
    };
  },
  computed: {
    inviteUserInfo: function inviteUserInfo() {
      return this.$store.state.inviteUserInfo;
    },
    orderState: function orderState() {
      return this.$store.state.orderState;
    },
    ticketReady: function ticketReady() {
      return this.$store.state.ticketReady;
    },
    isSelf: function isSelf() {
      if (!this.inviteUserInfo) {
        return false;
      }

      return config.vuid === "".concat(this.inviteUserInfo.vuid);
    },
    isLiveOrder: function isLiveOrder() {
      try {
        var order = this.$store.state.inviteOrderInfo;
        return new Date(order.lCreatTime * 1000) < new Date(window.setting.直播结束时间);
      } catch (e) {
        return false;
      }
    },
    settingConfig: function settingConfig() {
      return window.setting.领取弹窗;
    }
  },
  watch: {
    ticketReady: function ticketReady() {
      this.tip();
    }
  },
  methods: {
    blackTip: function blackTip() {
      var _this = this;

      this.confirm({
        msg: '您的账号存在安全风险，请联系客服处理。',
        align: 'left',
        confirmText: '联系客服',
        confirm: function confirm() {
          _this.openKefu();
        }
      });
    },
    levelIcon: function levelIcon(level) {
      return +level > 0 ? VIPICON[level] : '';
    },
    launchShare: function launchShare() {
      Bus.$emit('launchShare', {
        type: this.isSelf ? 0 : 2,
        num: this.isSelf ? this.selfTicketCount : 1,
        sendDesc: this.isSelf ? '已支持' : '已获得'
      });
    },
    tip: function tip() {
      // 已经有票了，且是从别人的邀请链接进来的
      if (!this.isSelf) {
        if (this.ticketReady && this.hasTicket && this.inviteUserInfo) {
          this.toast('你已拥有电子票咯，无需重复领取哟~');
        }
      }
    },
    dot: function dot(nick) {
      return cutStrWithEmoji(nick, 10);
    },
    openBuy: function openBuy() {
      this.visible = false;
      Bus.$emit('checkBuyTicket');
    },
    clearKey: function clearKey() {
      var _window2 = window,
          location = _window2.location,
          history = _window2.history;

      try {
        var url = location.href;
        var keys = ['userid', 'orderid'];
        keys.forEach(function (key) {
          url = delQueStr(url, key);
        });

        if (history.replaceState) {
          history.replaceState(null, document.title, url);
        }
      } catch (e) {
        console.error(e);
      }
    },
    receiveTicket: function receiveTicket() {
      var _this2 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var code, res;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (!_this2.hasTicket) {
                  _context.next = 3;
                  break;
                }

                _this2.toast('您已拥有直播票不可重复领取哦~');

                return _context.abrupt("return");

              case 3:
                _context.prev = 3;
                _context.next = 6;
                return TicketService.receiveOrder(config.orderid);

              case 6:
                _this2.visible = false;

                _this2.launchShare();

                Bus.$emit('refreshTicketInfo');
                _context.next = 43;
                break;

              case 11:
                _context.prev = 11;
                _context.t0 = _context["catch"](3);
                code = +_context.t0.code;
                res = _context.t0.res;

                if (!(code === -10003)) {
                  _context.next = 19;
                  break;
                }

                _this2.loginTips();

                _context.next = 43;
                break;

              case 19:
                if (!(code === -10006)) {
                  _context.next = 23;
                  break;
                }

                _this2.toast('已经领取过了哦，风里雨里，直播等你~');

                _context.next = 43;
                break;

              case 23:
                if (!(code === -10008)) {
                  _context.next = 27;
                  break;
                }

                _this2.toast('朋友来晚啦，活动已结束~');

                _context.next = 43;
                break;

              case 27:
                if (!(code === -10009)) {
                  _context.next = 31;
                  break;
                }

                _this2.toast('来晚啦，票被其他朋友领完啦~');

                _context.next = 43;
                break;

              case 31:
                if (!(code === -10010 || code === 101)) {
                  _context.next = 35;
                  break;
                }

                _this2.blackTip();

                _context.next = 43;
                break;

              case 35:
                if (!(res && res.data && res.data.secInfo)) {
                  _context.next = 42;
                  break;
                }

                _this2.shield.setStrategy(res.data.secInfo);

                _context.next = 39;
                return _this2.shield.run();

              case 39:
                _this2.receiveTicket();

                _context.next = 43;
                break;

              case 42:
                _this2.toast('啊哦，服务器开小差了，请稍后再试~');

              case 43:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, null, [[3, 11]]);
      }))();
    }
  },
  mounted: function mounted() {
    this.shield = new VftShield();
    this.tip(); // 每次进入页面后都清掉邀请的参数

    if (window.setting.清理邀请参数) {
      if (this.loginService.isLogin) {
        this.clearKey();
      }
    }
  }
};